import { IconEnum } from '../enums/icon.enum';
import { OptionMenuEnum } from '../enums/option-menu.enum';

export class MenuOption {

    /** Id de la pantalla en BD. 0 para módulos/submódulos. */
    screenId: number = 0;
    moduleType: OptionMenuEnum = OptionMenuEnum.Screen;
    /** Clave de la pantalla en BD (ej. "Home"). Vacío para módulos/submódulos. */
    key: string = '';
    path: string = '';
    title: string = '';
    icon: string = 'fa-circle-o';
    homeScreen: boolean = false;
    isOpen: boolean = false;
    isActive: boolean = false;
    subMenu: Array<MenuOption> = [];
    order: number = 0;
    homeOrder: number = 0;
    description?: string = '';

    constructor(init?: Partial<MenuOption>) {
        Object.assign(this, init);
    }

}
